<!-- End Navbar -->
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary" style="height: 3.75rem">
            <h4 class="card-title">{{sociedad}}</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <th>ID.</th>
                  <th style="width: 300px;">N. {{ 'texto_71' | translate }}</th>
                  <th>{{ 'texto_63' | translate }}</th>
                  <th>{{ 'texto_490' | translate }}</th>
                  <th>{{ 'texto_690' | translate }}</th>
                  <th>{{ 'texto_754' | translate }}</th>
                  <th style="width: 150px;"></th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of denuncias">
                    <td>{{ item.id_tp_denuncia }}</td>
                    <td>{{ item.nombre }}</td>
                    <td>
                      <div *ngIf="item.descripcion; else noDesc" [innerHtml]="item.descripcion | safe: 'html'"></div>
                      <ng-template #noDesc>{{ 'texto_937' | translate }}</ng-template>
                    </td>
                    <td>{{ item.n_gestor ? item.n_gestor : ('texto_938' | translate) }}</td>
                    <td>{{ item.n_gestor_conflicto ? item.n_gestor_conflicto : ('texto_938' | translate) }}</td>
                    <td>{{ item.orden }}</td>
                    <td class="td-actions text-right">
                      <!-- Botón Editar -->
                      <button (click)="openEdit(item)" type="button" rel="tooltip" title="Edit Complaint"
                        style="background: none;color:black;border:none;">
                        <i class="material-icons">edit</i>
                      </button>

                 <!-- Botón Eliminar (X) -->
                  <button (click)="deleteComplaintType(item)" type="button" title="Eliminar"
                      style="background: none;color:red;border:none;">
                    <i class="material-icons">clear</i>
                  </button>

                  <!-- Botón Activar/Desactivar (Ojo) -->
                  <button (click)="toggleVisibility(item)" type="button"
                      [title]="item.is_visible === 1 ? 'Desactivar' : 'Activar'"
                      [style.color]="item.is_visible === 1 ? 'green' : 'orange'"
                      style="background: none;border:none;">
                    <i class="material-icons">
                      {{ item.is_visible === 1 ? 'visibility' : 'visibility_off' }}
                    </i>
                  </button>


                    </td>
                  </tr>
                </tbody>
              </table>

              <br><br>
              <button style="float: right;" class="btn btn-primary" type="button" mdbBtn rounded="true"
                (click)="openCreate()" mdbWavesEffect>
                {{ 'texto_60' | translate }}
              </button>

              <!-- Modal para crear/editar -->
              <div *ngIf="showModal" class="modal-overlay"
                style="position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:flex-start;justify-content:center;background:rgba(0,0,0,0.35);z-index:2000;">
                <div class="modal-dialog modal-sm" style="z-index:2050;margin:0 auto;">
                  <app-add-tipo-denuncia [embedded]="true" [tipoToEdit]="selectedTipo" (close)="closeModal()"
                    (saved)="onSaved($event)">
                  </app-add-tipo-denuncia>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
